import axios from "axios";

// axios.defaults.baseURL = 'http://cms.yuntuys.com/api';

axios.defaults.baseURL = 'http://open-service.yuntuys.com/api';

// axios.defaults.baseURL = 'http://192.168.2.2:8080/api';


/**
 * product  产品校验
 * getChoiceByPidWithBook 获取首页主题分类
 * getClassTypeToHome  获取分类页面的所有分类
 * getClassTypeByPid  根据父级分类id获取子集分类
 * getBookListByType  根据分类id获取该分类的书籍列表
 * getChoiceByPid      获取精选分类
 * getHaveOrNoChildrenToPid  获取分类子集
 * getBook   根据书籍id获取书籍信息
 * getChapter 根据书籍id获取章节列表
 * addBookReadSum  添加书籍播放量
 * getHomeSlide   首页轮播图
 * getCarousel  首页轮播图
 * getBookSeries   点击轮播图获取系列书籍列表
 * hotListening   重磅热听
 * newArrival     最新上架
 * userMayLike       猜你喜欢
 * addUserBookCollect  收藏
 * delUserBookCollect  取消收藏
 * userBookCollect       获取用户收藏列表
 * addUserBookHistory    添加历史记录
 * delUserBookHistory     删除历史记录
 * userBookHistory       获取用户历史记录列表
 * searchList          搜索 获取列表 
 * login      用户名登录
 * changePasd  修改密码
 * logout     用户退出
 */
const allApi = {
    product: (data) => { return axios.get("/auth/w_ys/product/" + data.changed + "/" + data.officeId + "/" + data.classTypeId, {params: data.ticket}) },

    getHomeSlide: (data) => { return axios.get("/w_ys/slide_show/getHomeSlide/" + data.ticket + "/" + data.slideType) },

    getCarousel: (data) => { return axios.get("/w_ys/carousel/getCarousel/" + data.ticket) },

    getBookSeries: (data) => { return axios.get("/w_ys/carousel/getBookSeries/" + data.ticket + "/" + data.carouselId, {params: data.page}) },

    getChoiceByPid: (data) => { return axios.get("/w_ys/class_type/getChoiceByPid/" + data.classTypeId) },

    hotListening: (data) => { return axios.get("/w_ys/book/hotListening/" + data.ticket, {params: data.page}) },

    newArrival: (data) => { return axios.get("/w_ys/book/newArrival/" + data.ticket, {params: data.page}) },

    userMayLike: (data) => { return axios.get("/w_ys/book/userMayLike/" + data.ticket, {params: data.page}) },

    getChoiceByPidWithBook: (data) => { return axios.get("/w_ys/class_type/getChoiceByPidWithBook/" + data.ticket) },

    getClassTypeByPid: (data) => { return axios.get("/w_ys/class_type/getClassTypeByPid/" + data.classTypePid) },
    
    getHaveOrNoChildrenToPid: (data) => { return axios.get("/w_ys/class_type/getHaveOrNoChildrenToPid/" + data.classTypePid) },    

    getBookListByType: (data) => { return axios.get("/w_ys/book/getBookListByType/" + data.ticket + "/" + data.classTypeId, {params: data.page}) },

    getBook: (data) => { return axios.get("/w_ys/book/getBook/" + data.ticket + "/" + data.bookId) },

    getChapter: (data) => { return axios.get("/w_ys/book/getChapters/" + data.ticket + "/" + data.bookId + "/" + data.historical + "/" + data.rankOrder, {params: data.page}) },

    addBookReadSum: (data) => { return axios.get("/w_ys/book/addBookReadSum/" + data.ticket + "/" + data.bookId) },

    getClassTypeToHome: (data) => { return axios.get("/w_ys/class_type/getClassTypeToHome/" + data.classTypeId) },

    addUserBookCollect: (data) => { return axios.get("/w_ys/book/addUserBookCollect/" + data.ticket + "/" + data.bookId) },
    
    delUserBookCollect: (data) => { return axios.get("/w_ys/book/delUserBookCollect", {params: data}) },

    userBookCollect: (data) => { return axios.get("/w_ys/book/userBookCollect/" + data.ticket, {params: data.page}) },

    addUserBookHistory: (data) => { return axios.get("/w_ys/book/addUserBookHistory/" + data.ticket + "/" + data.bookId + "/" + data.chapterId + "/" + data.chapterRank + "/" + data.duration) },

    delUserBookHistory: (data) => { return axios.get("/w_ys/book/delUserBookHistory", {params: data}) },

    userBookHistory: (data) => { return axios.get("/w_ys/book/userBookHistory/" + data.ticket, {params: data.page}) },

    searchList: (data) => { return axios.get("/w_ys/book/search/" + data.ticket + "/" + data.search, {params: data.page}) },

    login: (data) => { return axios.get("/auth/login/" + data.ticket + "/" + data.loginName + "/" + data.password) },

    changePasd: (data) => { return axios.post("/auth/changePasd", data) },

    logout: (data) => { return axios.get("/auth/logout/" + data.ticket) },

    wailianBookList: (data) => { return axios.get("/carousel/getBook/" + data.deptId + "/" + data.carouselId, {params: data.page}) },
    
}
export default allApi;